export default __webpack_public_path__ + "static/media/BiofuelCircleLogo.a4ae2979.png";